import React, { useContext, useMemo } from "react";
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import moment from "moment";
import { Box, FormControl, MenuItem, Select } from "@material-ui/core";
import { storeContext } from "../../provider/Provider";
import { digitalPRActions } from "../../../store/digital-pr-reducer";
import CONSTANTS from "../../../utils/constants";

export const useLinkDialog = () => {
    const { state, dispatch } = useContext(storeContext);


    const handleMediaClick = (url) => {
        dispatch({
            type: digitalPRActions.SET_LINKS_DIALOG_OPEN,
            payload: {
                isVideoOpen: false
            }
        });
        dispatch({
            type: digitalPRActions.SET_IS_VIDEO_OPEN,
            payload: {
                isVideoOpen: true
            }
        });
        dispatch({
            type: digitalPRActions.SET_VIDEO_URL,
            payload: {
                videoUrl: url
            }
        });
    };

    const handleFilterChange = (value) => {
        dispatch({
            type: digitalPRActions.SET_SELECTED_LINK_TYPE,
            payload: { 
               selectedLinkType: value,
            }
        });
    }
    const linkColumns = [
        {
           header: "No.",
           key: "id",
           cell: (row) => (<Box>{state.digitalPR.linkList.findIndex(link => link.id === row.id)+1}</Box>),
           cellStyle: { fontSize: "1.05rem" },
        },
        {
           header: "Link",
           key: "url",
           cell: (row) => (
             row.url ? (
               <a href={row.url} target="_blank" rel="noreferrer" style={{ color: '#2A5CA9', textDecoration: 'underline', wordBreak: 'break-all' }}>
                 {row.url}
               </a>
             ) : (
               <span>n/a</span>
             )
           ),
           cellStyle: { fontSize: "1.05rem" },
        },
        {
            header: "Media",
            key: "media_link",
            cell: (row) => (row.media_link? 
                <Box 
                onClick={() => handleMediaClick(row.media_link)} 
                display='flex' 
                flex={1}                
                style={{width: "100%", cursor: 'pointer'}}>
                <PlayCircleOutlineIcon style={{ fontSize: 20 }} />
                </Box>: 
                "n/a"),
            cellStyle: { fontSize: "1.05rem" },
        },
        {
           header: (<FormControl variant="outlined" style={{ minWidth: 70 }}>
                <Select
                value={state.digitalPR.selectedLinkType}
                onChange={(event) => {
                    handleFilterChange(event.target.value)
                }}
                label="Link Type"
                aria-label="select link type"
                >
                {CONSTANTS.availableLinkTypes.map((type) => (
                    <MenuItem value={type.value} key={type.value}>
                    {type.label}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>),
           key: "dr",
           cellStyle: { fontSize: "1.05rem" },
        },
        {
           header: "Published",
           key: "date",
           cellStyle: { padding: "15px 0", fontSize: "1.05rem" },
           cell: (row) => (<Box>{moment(row.date).format("MM/DD/YYYY")}</Box>),
        },
     ]

     const style = {
        tableHead: {
           backgroundColor: "#F2F5F7", 
        },
        headCell: {
           color: "#101010",
           fontSize: "1.05rem",
        },
        cell: {
           fontSize: "1.05rem",
        }
     }

    const filteredLinks = useMemo(() => state.digitalPR.selectedLinkType === "+70"? state.digitalPR.linkList.filter((link) => link.dr >= 70): state.digitalPR.linkList, [state.digitalPR.linkList, state.digitalPR.selectedLinkType])

    return {
        linkColumns,
        style,
        filteredLinks,
    }
}

export default useLinkDialog;

